export default {
  paymentToUpgrade: {
    en: 'PAYMENT TO UPGRADE',
  },
  orderButton: {
    en: 'Order now',
  },
  freeShipping: {
    en: 'Free shipping',
  },
  tax: {
    en: '+ tax',
  },
  close: {
    en: 'Close',
  },
}
